import React from 'react';
import Sidebar from './Sidebar';

interface LayoutProps {
  children: React.ReactNode;
  className?: string;
}

const Layout: React.FC<LayoutProps> = ({ children, className = '' }) => {
  return (
    <div className="min-h-screen bg-gray-50 flex">
      <Sidebar />
      <div className="flex-1 flex flex-col md:ml-16">
        <main className={`flex-1 px-4 py-4 md:px-6 md:py-6 mt-16 md:mt-0 ${className}`}>
          <div className="container mx-auto max-w-8xl">
            {children}
          </div>
        </main>
        <footer className="bg-white border-t border-gray-200 py-6 px-4">
          <div className="container mx-auto text-center text-gray-500 text-sm">
            &copy; {new Date().getFullYear()} Bluepill Inc.
          </div>
        </footer>
      </div>
    </div>
  );
};

export default Layout;